import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ReportState {
  data: Record<string, any>;
}

const initialState: ReportState = {
  data: {},
};

const reportSlice = createSlice({
  name: 'reportSlice',
  initialState,
  reducers: {
    addReport: (state, action: PayloadAction<any>) => {
      const key = new Date().toLocaleString();
      state.data[key] = action.payload;
    },
  },
});

export const { addReport } = reportSlice.actions;
export default reportSlice.reducer;
